module.exports = __webpack_public_path__ + "img/news1.d493cc83.jpg";